export const CARD_GAP = 16;
